import { FlexColumn, FlexRow, LabeledData } from '@gorila-shared-ui/components';
import { FleetDriver } from '../../../../types/drivers';
import { StyledCard } from '../../../shared/styledCard/StyledCard';
import { StyledCardBodyWrapper } from '../../../shared/styledCard/StyledCardBodyWrapper';
import FleetDriverAvatar from './FleetDriverAvatar';

type Props = Readonly<{
  driver: FleetDriver;
}>;

function FleetDriverMatchingCard({ driver }: Props) {
  const labelWidth = '140px';

  return (
    <StyledCard>
      <StyledCardBodyWrapper>
        <FlexRow>
          <FleetDriverAvatar
            lastName={driver.lastName}
            name={driver.name}
            photo={driver.photo}
            size="130px"
          />
          <FlexColumn gap={0}>
            <LabeledData
              label="Nombre(s):"
              content={driver.name || '-'}
              inline={false}
              maxLines={5}
              labelWidth={labelWidth}
            />
            <LabeledData
              label="Apellido(s):"
              content={driver.lastName || '-'}
              inline={false}
              maxLines={5}
              labelWidth={labelWidth}
            />
            <LabeledData
              label="Teléfono:"
              content={driver.phone || '-'}
              inline={false}
              maxLines={5}
              labelWidth={labelWidth}
            />
            <LabeledData
              label="Correo electrónico:"
              content={driver.email || '-'}
              inline={false}
              maxLines={5}
              labelWidth={labelWidth}
            />
            <LabeledData
              label="Número de licencia:"
              content={driver.licenseNumber || '-'}
              inline={false}
              maxLines={5}
              labelWidth={labelWidth}
            />
            <LabeledData
              label="Expiración licencia:"
              content={driver.licenseExpiry || '-'}
              inline={false}
              maxLines={5}
              labelWidth={labelWidth}
            />
          </FlexColumn>
        </FlexRow>
      </StyledCardBodyWrapper>
    </StyledCard>
  );
}

export default FleetDriverMatchingCard;
